import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieAPIService } from 'src/app/extensions/services/api/cookie-api.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CookieEvents } from 'src/app/extensions/services/api/events';
import { DeleteItemModalComponent } from 'src/app/extensions/components/delete-item-modal/delete-item-modal.component';
import { map } from 'rxjs';
import { COOKIE_STATUS } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'terms-and-conditions',
  templateUrl: './terms-and-conditions-list.component.html',
  styleUrls: ['./terms-and-conditions-list.component.scss'],
  standalone: false,
})
export class TermsAndConditionsListComponent implements OnInit {
  public cookieMessages: app.models.CookieModel[];
  public props: app.models.DynamicPropsDictionary;
  public hasNoData = true;

  public constructor(
    private _cookieAPIService: CookieAPIService,
    private _ngbModal: NgbModal,
    private _router: Router,
    private _translateService: TranslateService,
    private _notificationService: NotificationService
  ) {}

  public ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this._cookieAPIService
      .getCookieMessages()
      .pipe(
        map(x => {
          return {
            ...x,
            data: x.data.map(item => {
              let status = COOKIE_STATUS.EXPIRED;
              let today = new Date();
              if (item.active) {
                status = COOKIE_STATUS.ACTIVE;
              } else if (new Date(item.startDate) > today) {
                status = COOKIE_STATUS.UPCOMING;
              } else if (new Date(item.endDate) < today) {
                status = COOKIE_STATUS.EXPIRED;
              }
              return {
                ...item,
                status,
              };
            }),
          };
        })
      )
      .subscribe(result => {
        this.cookieMessages = result.data;
        this.props = result.props;
        this.hasNoData = this.cookieMessages.length == 0;
      });
  }

  createNewCookieMessage() {
    this._router.navigate(['terms-and-conditions/new']);
  }

  editCookieHandler = (cookieMessageId: string) => {
    this._router.navigate(['terms-and-conditions', cookieMessageId]);
  };

  redirectCookieConsent = (cookieMessageId: string) => {
    this._router.navigate(['terms-and-conditions/consent', cookieMessageId]);
  };

  deleteCookieHandler = (cookieMessageId: string = null) => {
    if (cookieMessageId) {
      const deleteCookieMessageModal = this._ngbModal.open(DeleteItemModalComponent, { backdrop: 'static' });

      deleteCookieMessageModal.componentInstance.title = 'termsAndConditions.deleteCookieMessageTitle';

      deleteCookieMessageModal.componentInstance.item = this.cookieMessages.find(
        cookieMessage => cookieMessage.cookieMessageId === cookieMessageId
      ).title;
      deleteCookieMessageModal.componentInstance.warninglabel = this._translateService.instant(
        'termsAndConditions.deleteCookieMessageWarning'
      );
      deleteCookieMessageModal.result.then(result => {
        if (result) {
          this._cookieAPIService.deleteCookieMessage(cookieMessageId).subscribe(response => {
            if (response.isSuccess) {
              this.cookieMessages = this.cookieMessages.filter(x => x.cookieMessageId != cookieMessageId);
              this._notificationService.showSuccess(
                this._translateService.instant('termsAndConditions.add.notifications.cookieMessageDeleted'),
                this._translateService.instant('common.success')
              );
              this.cookieMessages.find(
                x =>
                  x.cookieMessageId ===
                  response.response.events.find(y => y.eventType === CookieEvents.CookieMessageDeleted).eventBody
                    ?.previousCookieMessageId
              ).endDate = response.response.events.find(
                y => y.eventType === CookieEvents.CookieMessageDeleted
              ).eventBody?.previousCookieEndDate;
            } else {
              this._notificationService.showError(
                this._translateService.instant('termsAndConditions.add.notifications.cookieMessageDeleteFailed'),
                this._translateService.instant('common.error')
              );
            }
          });
        }
      });
    }
  };
}
